import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  isFetching: false,
  hasInitialized: false,
  error: null,
  items: {},
}

export const fetchPublishedApps = createAsyncActions('apps/published')
export const fetchAppInfo = createAsyncActions('apps/fetchInfo')

/*
  List of all published apps so we will always have latest information about the apps
*/
const publishedAppsSlice = createSlice({
  name: 'publishedApps',
  initialState,
  extraReducers: ({ addCase }) => {
    addCase(fetchPublishedApps.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(fetchPublishedApps.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = payload.items
      state.hasInitialized = true
    })

    addCase(fetchPublishedApps.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
      state.hasInitialized = true
    })

    addCase(fetchAppInfo.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(fetchAppInfo.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = {
        ...state.items,
        [payload?.item?.id]: payload?.item,
      }
    })

    addCase(fetchAppInfo.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })
  },
})

export const reducer = publishedAppsSlice.reducer
